import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/allies/allies/store/tradeMarkSlice/initialState.ts'

const tradeMarkSlice = createSlice({
  name: 'tradeMark',
  initialState,
  reducers: {
    setIsCreateTradeMarkModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateTradeMarkModalOpen = action.payload
    },
    setIsEditTradeMarkModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditTradeMarkModalOpen = action.payload
    },
    setSelectedTradeMarkId: (state, action: PayloadAction<string | null>) => {
      state.selectedTradeMarkId = action.payload
    },
    setTradeMarkFilters: (state, action: PayloadAction<string>) => {
      state.trademarkFilters = action.payload
    },
    reset: () => initialState
  }
})

export const tradeMarkActions = tradeMarkSlice.actions
export const { reducer: tradeMarkReducer } = tradeMarkSlice
